import { render, staticRenderFns } from "./BeerPostLabQ2.vue?vue&type=template&id=6dbd5fee&"
import script from "./BeerPostLabQ2.vue?vue&type=script&lang=js&"
export * from "./BeerPostLabQ2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
